import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { MainCard } from "../../components";
import DocumentsList from "./DocumentsList";
import { DOCUMENTS } from "../../helpers/accessModule";
import { LIST_DOCUMENTS } from "../../helpers/accessSubmodule";
import { useNavigate } from "react-router-dom";
import { useStore } from "react-redux";

const Documents = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const store = useStore();

    const { module, submodules } = store.getState().auth.access;

    useEffect(() => {
        if (!module.includes(DOCUMENTS)) {
            navigate("/403");
        }
    }, []);

    return (
        <Grid container rowSpacing={4.5} columnSpacing={2.75}>
            {submodules.includes(LIST_DOCUMENTS) && (
                <Grid item xs={12} md={12} lg={12}>
                    <MainCard title={t("listedesdocuments")}>
                        <DocumentsList />
                    </MainCard>
                </Grid>
            )}
        </Grid>
    );
};

export default Documents;
